import LocationToLocationCountryImageType
    from "@Pages/stationToStation/features/header/types/LocationToLocationCountryImage.type";
import BackgroundImageCanvas from "@Form/components/BackgroundImageCanvas";

type LocationToLocationBackgroundImageProps = {
    imagePaths: LocationToLocationCountryImageType
}

function LocationToLocationBackgroundImage({imagePaths}: LocationToLocationBackgroundImageProps) {
    const {
        pathMobile,
        pathTablet,
        pathWindow,
    } = imagePaths

    const hasWindow = typeof pathWindow === 'string' && pathWindow.length > 0
    const hasTablet = typeof pathTablet === 'string' && pathTablet.length > 0
    const hasAnyImage = hasWindow || hasTablet
    // 1×1 transparent GIF (single-pixel "spacer" image)
    const placeholderSrc = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='

    return (
        <picture className="gb--navigation-background">
            <BackgroundImageCanvas imagePaths={imagePaths}/>
            {hasWindow && (
                <source
                    media="(min-width: 992px)"
                    type="image/jpg"
                    srcSet={pathWindow}
                />
            )}
            {hasTablet && (
                <img
                    className="background-image"
                    typeof="image/jpg"
                    src={pathTablet}
                    alt="heading"
                />
            )}
            {!hasAnyImage && (
                <img
                    className="background-image"
                    typeof="image/gif"
                    src={placeholderSrc}
                    alt="heading"
                    style={{width: '100%'}}
                />
            )}
        </picture>
    )
}

export default LocationToLocationBackgroundImage